import { useEffect } from "react"
import {
  useGetDaysSinceLastUnlock,
  useSetNonStaleCarrotPlanOnAnniversaryCheck
} from "../../../carrot-plans/case-rate-renewals/useQueryCaseRateRenewals"

/**
 * Members with incomplete CPES data can incorrectly appear ungated upon case rate renewal.
 * This hook ensures NOT_GATED members get properly evaluated on login to prevent bypassing the renewal flow.
 */
export function useOnLoginCarrotPlanAnniversaryCheck() {
  const { mutate: setNonStaleCarrotPlanOnAnniversaryCheck } = useSetNonStaleCarrotPlanOnAnniversaryCheck()
  const { data: daysFromLastUnlock } = useGetDaysSinceLastUnlock()

  useEffect(() => {
    if (daysFromLastUnlock >= 365) {
      setNonStaleCarrotPlanOnAnniversaryCheck(null)
    }
  }, [daysFromLastUnlock, setNonStaleCarrotPlanOnAnniversaryCheck])
}
